var $94b34635baf16223$exports = {};
$94b34635baf16223$exports = {
    "Empty": `\u{7A7A}\u{767D}`
};


export {$94b34635baf16223$exports as default};
//# sourceMappingURL=zh-TW.mjs.map
